<nz-date-picker
        [nzAllowClear]="nzAllowClear"
        [nzAutoFocus]="nzAutoFocus"
        [nzDateRender]="nzDateRender"
        [nzDisabled]="nzDisabled"
        [nzDisabledDate]="nzDisabledDate"
        [nzLocale]="nzLocale"
        [nzPopupStyle]="nzPopupStyle"
        [nzDropdownClassName]="nzDropdownClassName"
        [nzSize]="nzSize"


        [nzDisabledTime]="nzDisabledTime"
        [nzFormat]="nzFormat"
        [nzRenderExtraFooter]="nzRenderExtraFooter"
        [nzShowTime]="nzShowTime"
        [nzShowToday]="nzShowToday"
        [nzPlaceHolder]="nzPlaceHolder"

        [(ngModel)]="value"
        (nzOnOk)="onNzOk($event)"
        (ngModelChange)="onNgModelChangeChange($event)"
        (nzOnOpenChange)="onNzOnOpenChange($event)">

</nz-date-picker>
